module.exports = __webpack_public_path__ + "05_medium_brown.e50a1f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_medium_brown.png
// module id = y3DH
// module chunks = 0